import { Connector } from 'wagmi';

import { store } from '@/shared/store';

export function getWagmiWalletState() {
    return store.getState().wagmi as {
        connector: Connector;
        address: string | null;
        chainId: string | null;
    };
}
